import axios from 'axios';
import router from "../router";

const request = axios.create({
    baseURL: process.env.NODE_ENV==='development'?'/api/':'https://cdb.0731app.cn/',
    timeout: 10000, // Request timeout
    headers: {
        'Content-Type': 'application/json',
        'Accept-Language':'zh-CN'
    },
});

// 拦截器 在请求之前拦截
request.interceptors.request.use(

    config => {
        const token = localStorage.getItem('UTOKEN');
        if (token) {
            config.headers['token'] =  token;
        }
        return config;
    },
    error => {
        // Do something with request error
        Promise.reject(error);
    }
);
// 拦截器 在请求之后拦截
request.interceptors.response.use(
    response => {
        if (response.headers.authorization) {
            localStorage.setItem('token',response.headers.authorization);
            response.data.token = response.headers.authorization;
        }
        if(response.data.code==-1){
            router.push('/login');
        }
        return response.data;
    },
    error => {
        if(!checkErrResponse(error)) return;
        return Promise.reject(error);
    },
);

function checkErrResponse(err) {
    return (err && err.response && err.response.data && err.response.data.status_code);

}
export default request;
